var map = {
	"./add-disabled.svg": "7450",
	"./add.svg": "76a4",
	"./alert-icon.svg": "dd45",
	"./arrow-left.svg": "ac3b",
	"./better-v.svg": "13eb",
	"./blacktrash.svg": "5222",
	"./close-fat.svg": "fd8e",
	"./close.svg": "8b1b",
	"./credit-card-outline.svg": "0535",
	"./edits-exclude.svg": "7f39",
	"./edits-move.svg": "6a40",
	"./edits-sub-category.svg": "08e2",
	"./edits-trash.svg": "dd9b",
	"./exclamation-mark.svg": "379f",
	"./exclemation-mark-coral.svg": "82051",
	"./exclemation-mark-gray.svg": "a2a7",
	"./exclemation-mark-yellow.svg": "d94a",
	"./flag-grey.svg": "1d60",
	"./flag.svg": "c26e",
	"./group-5.svg": "c92d",
	"./ic-close.svg": "d41d",
	"./icon-check-blue.svg": "8894",
	"./left-triangle.svg": "3eed",
	"./light-three-dots.svg": "0c5d",
	"./lock-blue.svg": "b47b",
	"./lock-grey.svg": "a7d1",
	"./lock-outline.svg": "5994",
	"./menu.svg": "d17f",
	"./modal-close-blue.svg": "0158",
	"./modal-close-mustard.svg": "3d49",
	"./mode-edit.svg": "af9c",
	"./notice-gray.svg": "c521",
	"./redtrash.svg": "7fc3",
	"./remove.svg": "5088",
	"./right-triangle.svg": "b750",
	"./search-grey.svg": "9d9a",
	"./search.svg": "d103",
	"./success-icon.svg": "13a1",
	"./three-dots.svg": "0960",
	"./trash.svg": "af22",
	"./v-blue.svg": "3fe6",
	"./v-outline.svg": "bf62",
	"./v.svg": "347a",
	"./warning-icon.svg": "209f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";